var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CButton',{staticClass:"!tw-bg-transparent !tw-border-0",attrs:{"title":_vm.$t('clear all'),"size":"sm","variant":"extra-light"}},[_c('fa',{attrs:{"icon":_vm.icons.deselect}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }